import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, } from 'react';
const PopupContext = createContext({
    headerRef: null,
    setHeaderRef: () => { },
    footerRef: null,
    setFooterRef: () => { },
    notificationRef: null,
    setNotificationRef: () => { },
    headerClassName: null,
    setHeaderClassName: () => { },
    footerClassName: null,
    setFooterClassName: () => { },
    notificationClassName: null,
    setNotificationClassName: () => { },
});
export function PopupContextProvider({ children }) {
    const [headerRef, setHeaderRef] = useState(null);
    const [footerRef, setFooterRef] = useState(null);
    const [notificationRef, setNotificationRef] = useState(null);
    const [headerClassName, setHeaderClassName] = useState(null);
    const [footerClassName, setFooterClassName] = useState(null);
    const [notificationClassName, setNotificationClassName] = useState(null);
    function setHeaderClass(className) {
        if (className) {
            setHeaderClassName(className);
        }
    }
    function setNotficationClass(className) {
        if (className) {
            setNotificationClassName(className);
        }
    }
    function setFooterClass(className) {
        if (className) {
            setFooterClassName(className);
        }
    }
    const value = {
        headerRef,
        setHeaderRef,
        footerRef,
        setFooterRef,
        notificationRef,
        setNotificationRef,
        headerClassName,
        setHeaderClassName: setHeaderClass,
        footerClassName,
        setFooterClassName: setFooterClass,
        notificationClassName,
        setNotificationClassName: setNotficationClass,
    };
    return _jsx(PopupContext.Provider, { value: value, children: children });
}
export function useFlowPopupContext() {
    return useContext(PopupContext);
}
//# sourceMappingURL=popup-context.js.map